var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4444 5V4.2C15.4444 3.0799 15.4444 2.51984 15.2022 2.09202C14.9892 1.71569 14.6492 1.40973 14.2311 1.21799C13.7557 1 13.1335 1 11.8889 1H10.1111C8.86655 1 8.24427 1 7.76891 1.21799C7.35077 1.40973 7.01082 1.71569 6.79776 2.09202C6.55556 2.51984 6.55556 3.0799 6.55556 4.2V5M8.77778 10.5V15.5M13.2222 10.5V15.5M1 5H21M18.7778 5V16.2C18.7778 17.8802 18.7778 18.7202 18.4145 19.362C18.0949 19.9265 17.585 20.3854 16.9577 20.673C16.2447 21 15.3113 21 13.4444 21H8.55556C6.68871 21 5.75529 21 5.04225 20.673C4.41505 20.3854 3.90511 19.9265 3.58553 19.362C3.22222 18.7202 3.22222 17.8802 3.22222 16.2V5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMessage);
export default __webpack_public_path__ + "static/media/delete_message.05f3c7b07ab393cf1af7f6ac4f056cb8.svg";
export { ForwardRef as ReactComponent };